import React from "react";
import { StationController } from "./StationController";
import { StationViewModel } from "./StationViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class StationProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new StationViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <StationController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Stations/StationProvider.js